import { BLUE, RED, VIOLET, GOLD } from "../../../data/colors";

const funnelChartsColors = [BLUE, RED, VIOLET, GOLD];

const MAX_NUMBER_QUANTITY_AFTER_DOT = 2;

export { funnelChartsColors, MAX_NUMBER_QUANTITY_AFTER_DOT };
